import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
} from '@angular/core';
import { Store } from '@ngxs/store';
import {
  catchError,
  filter,
  map,
  of,
  Subject,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs';
import { AsyncPipe, DecimalPipe } from '@angular/common';
import { TUI_PROMPT, TuiAccordionModule } from '@taiga-ui/kit';
import { SpaceNumberPipe } from '@shared/pipes/space-number.pipe';
import { TuiButtonModule, TuiDialogService } from '@taiga-ui/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AlertService } from '@shared/services/alert.service';
import { CargoCalculationState } from '../../store/cargo-calculation.state';
import { CargoPaymentComponent } from './components/cargo-payment/cargo-payment.component';
import { CargoCalculationService } from '../../services/cargo-calculation.service';

@Component({
  selector: 'app-cargo-payments',
  standalone: true,
  imports: [
    AsyncPipe,
    TuiAccordionModule,
    CargoPaymentComponent,
    DecimalPipe,
    SpaceNumberPipe,
    TuiButtonModule,
  ],
  templateUrl: './cargo-payments.component.html',
  styleUrl: './cargo-payments.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CargoPaymentsComponent implements OnInit {
  payments$ = this.store
    .select(CargoCalculationState.getSelectedCargo)
    .pipe(map(cargo => cargo?.payments ?? []));

  recalculatePayments$ = new Subject<void>();
  cargo$ = this.store.select(CargoCalculationState.getSelectedCargo);
  constructor(
    private readonly store: Store,
    private readonly dialogs: TuiDialogService,
    private readonly alert: AlertService,
    private readonly cargoCalculationService: CargoCalculationService,
    private readonly destroyRef: DestroyRef,
  ) {}

  recalculatePayments() {
    this.recalculatePayments$
      .pipe(
        switchMap(() =>
          this.dialogs
            .open<boolean>(TUI_PROMPT, {
              data: {
                content:
                  '<h1 class="font-bold text-lg">Пересчитать ставки ?<h1>',
                yes: 'Подтвердить',
                no: 'Отмена',
              },
            })
            .pipe(
              filter(submit => submit),
              withLatestFrom(this.cargo$),
              switchMap(([, cargo]) =>
                this.cargoCalculationService.calculate(cargo?.id ?? 0),
              ),
              tap(() => {
                this.alert.showSuccess();
              }),
            ),
        ),
        catchError(() => {
          this.alert.showError();
          return of(null);
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  ngOnInit() {
    this.recalculatePayments();
  }
}
